export default "__VITE_ASSET__Bzu1hK6E__"